import AuthService from '../service';

export default {
  methods: {
    proceedAuth() {
      const appId = this.getAppId();

      AuthService.proceedToSignIn(appId);
    },
    getAppId() {
      const { app } = this.$route.params;

      if (!app) {
        throw new Error('App is not specified');
      }

      return app;
    },
  },
}
